import $ from 'jquery';
import { selectors, classes, events } from '../Constants';
import layout from '../Layout';

export default class AccountExpand {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.onExpandClick = this._onExpandClick.bind(this);
    this.$expandButtons = $(selectors.account.expand, this.el);
    this.boundOnBreakpointChange = this._onBreakpointChange.bind(this);
    layout.onBreakpointChange(this.boundOnBreakpointChange);

    this._init();
  }

  _supportsExpandable() {
    return layout.isBreakpoint('XS') || layout.isBreakpoint('S');
  }

  _setExpandable(boolean) {
    if (boolean) {
      this.$expandButtons.on('click', this.onExpandClick);
      this.$el.removeClass(classes.account.expanded);
    } else {
      this.$expandButtons.off('click', this.onExpandClick);
    } 
  }

  _init() {
    this._setExpandable(this._supportsExpandable());
  }

  _onBreakpointChange() {
    if (layout.crossesThreshold()) {
      this._setExpandable(this._supportsExpandable()); 
    }
  }

  _onExpandClick(event) {
    const $target = $(event.currentTarget);
    const $expandable = $($target.siblings(selectors.account.expandable));
    $target.toggleClass(classes.account.expandable.expanded);
    $expandable.slideToggle();
  }
}